import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { orderBy, pickBy } from "lodash";
export default {
  name: "promote-config",
  data: function data() {
    return {
      searchForm: {
        city_id: "",
        group: ""
      },
      // 搜索表单
      cityList: [],
      // 修改档位
      updateGroupDialogVisible: false,
      updateGroupData: {},
      allGroups: {},
      // 预览描述
      previewData: {},
      previewGroupData: {},
      previewRadioValue: "",
      previewDialogVisible: false,
      // 添加/修改配置弹窗
      dialogVisible: false,
      form: {
        group: "A",
        index: "1"
      },
      tableLoading: false,
      tableData: [] // 表格数据
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    // 选择城市档位
    selectCityGroup: function selectCityGroup() {
      this.updateGroupData.groups = this.allGroups[this.updateGroupData.group];
    },
    // 修改档位弹窗
    updateGroupDialog: function updateGroupDialog(row) {
      this.updateGroupData = JSON.parse(JSON.stringify(row));
      this.updateGroupDialogVisible = true;
      if (Object.keys(this.allGroups).length == 0) {
        this.getCityGroup();
      }
    },
    // 修改档位
    updateCityGroup: function updateCityGroup() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.updateCityGroup({
                city_id: _this2.updateGroupData.city_id,
                group: _this2.updateGroupData.group
              });
            case 1:
              _this2.updateGroupDialogVisible = false;
              _this2.$message.success("保存成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 获取城市档位
    getCityGroup: function getCityGroup() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getCityGroup({
                city_id: _this3.updateGroupData.city_id
              });
            case 1:
              res = _context3.v;
              _this3.allGroups = res.data.groups_all;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 添加/修改配置弹窗
    addDialog: function addDialog() {
      this.dialogVisible = true;
      this.form = {
        group: "A",
        index: "1"
      };
      this.getPromoteConfig();
    },
    // 获取配置
    getPromoteConfig: function getPromoteConfig() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!_this4.form.group) {
                _this4.form.group = "A";
              }
              if (!_this4.form.index) {
                _this4.form.index = "1";
              }
              _context4.n = 1;
              return _this4.$api.getPromoteConfig({
                group: _this4.form.group,
                index: _this4.form.index
              });
            case 1:
              res = _context4.v;
              _this4.form = _objectSpread(_objectSpread({}, {
                group: _this4.form.group,
                index: _this4.form.index
              }), res.data);
              console.log(res);
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 保存配置
    setPromoteConfig: function setPromoteConfig() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.setPromoteConfig(_this5.form);
            case 1:
              _this5.$message.success("保存成功");
              _this5.getData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 预览描述切换
    previewRadioValueChange: function previewRadioValueChange() {
      var _this6 = this;
      this.previewData.groups.forEach(function (item) {
        if (_this6.previewRadioValue == item.token) {
          _this6.previewGroupData = item;
        }
      });
    },
    // 预览描述
    previewDialog: function previewDialog(row) {
      this.previewData = row;
      if (row.groups.length > 0) {
        this.previewRadioValue = row.groups[0].token;
        this.previewGroupData = row.groups[0];
      } else {
        this.previewGroupData = {};
      }
      console.log(row);
      this.previewDialogVisible = true;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    // 获取配置列表
    getData: function getData(type) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this7.tableLoading = true;
              _context6.n = 1;
              return _this7.$api.getPromoteConfigList(pickBy(_this7.searchForm));
            case 1:
              res = _context6.v;
              res.data.forEach(function (item) {
                item.cost = [];
                item.duration = [];
                item.promote_user_count = [];
                if (item.groups.length > 0) {
                  item.groups.forEach(function (group) {
                    item.cost.push(group.cost);
                    item.duration.push(group.duration);
                    item.promote_user_count.push(group.promote_user_count);
                  });
                }
              });
              res.data = orderBy(res.data, ["group"], ["asc"]);
              _this7.tableData = res.data;
              _this7.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    // 获取城市列表
    getCityList: function getCityList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this8.$api.getCityList({
                isOpen: 1,
                ps: 100
              });
            case 1:
              res = _context7.v;
              _this8.cityList = res.data.list;
              _this8.tableLoading = false;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    }
  }
};